const convertorNumberCircumcision = (value, decimalCount = 2, decimal = '.') => {
  decimalCount = Math.abs(decimalCount);
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

  const bitDepth = +`1${Array.apply(null, Array(decimalCount)).map(Number.prototype.valueOf, 0).join('')}`;
  const negativeSign = value < 0 ? '-' : '';
  value = Math.floor((value) * bitDepth) / bitDepth;

  return `${negativeSign}${Math.abs(value)}`;
};

export {
  convertorNumberCircumcision,
};
